module.exports = __webpack_public_path__ + "static/images/history.f5e06ddcd68a5c7edd033788547464c8.svg";